import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import getClientAccessTokenOperation from 'owa-service/lib/operation/getClientAccessTokenOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import getClientAccessTokenRequest from 'owa-service/lib/factory/getClientAccessTokenRequest';
import Token from 'owa-service/lib/contract/Token';

const LokiAuthTokenId = '94c63fef-13a3-47bc-8074-75af8c65887a';
const LOGGING_SCENARIO_NAME = 'OwaPeopleLoki_GetLokiAuthTokenOperation';

export default async function getLokiAuthTokenAsync(): Promise<string> {
    let request = {
        Header: getJsonRequestHeader(),
        Body: getClientAccessTokenRequest({
            TokenRequests: [
                {
                    __type: 'TokenRequest:#Exchange',
                    Id: LokiAuthTokenId,
                    TokenType: 'Loki',
                },
            ],
        }),
    };

    const dataPoint = new PerformanceDatapoint(LOGGING_SCENARIO_NAME);

    try {
        let results = await getClientAccessTokenOperation(request);

        if (results && results.Body.ResponseMessages.Items[0].ResponseClass == 'Success') {
            dataPoint.end();
            return (<Token>(<any>results.Body.ResponseMessages.Items[0]).Token).TokenValue;
        }
        dataPoint.endWithError(
            DatapointStatus.ServerError,
            Error(results.Body.ResponseMessages.Items[0].ResponseCode)
        );
        return null;
    } catch (e) {
        dataPoint.endWithError(DatapointStatus.ClientError, e);
        return null;
    }
}
